export function InfoIcon({ className }: { className?: string }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="10" cy="10" r="8.5" stroke="#8C929C" strokeWidth="1.5" />
      <path
        d="M10 13.333V10M10 6.667h.008"
        stroke="#8C929C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
